import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { fetchTemplates } from '../../store/actions/broadcastAction';
import Header from '../../components/Header'
import CssBaseline from '@material-ui/core/CssBaseline';
import Menubar from '../../components/Menubar';
import { Button, Grid, TextField } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import { Typography, Box, Chip } from '@material-ui/core';
import CircleIcon from '@mui/icons-material/Circle';
import SearchIcon from '@mui/icons-material/Search';
import { styled, alpha } from '@mui/material/styles';
import InputBase from '@mui/material/InputBase';
import FormControl from '@mui/material/FormControl';
import NativeSelect from '@mui/material/NativeSelect';
import ArrowDropDownSharpIcon from '@mui/icons-material/ArrowDropDownSharp';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import Moment from "moment"
import { loginRegisterUser } from '../../store/actions/userAction';

const useStyles = makeStyles((theme) => ({
    appBar: {
      position: 'relative',
    },
    layoutMainCreateApp: {
      background: "white",
      padding: "2rem 2rem",
      borderRadius: "10px",
      [theme.breakpoints.up("sm")]: {
        width: "80%",
        marginLeft: 'auto',
        marginRight: 'auto',
      },
    },
    stepper: {
      padding: theme.spacing(3, 0, 5),
    },
    buttons: {
      display: 'flex',
      justifyContent: 'flex-end',
    },
    button: {
      marginTop: theme.spacing(3),
      marginBottom: theme.spacing(3),
      marginLeft: theme.spacing(1),
    },
    contentCreateApp : {
      paddingTop: "3%",
      paddingLeft: "15%",
      backgroundColor: "#e8e8e8",
      paddingRight: "0%",
      paddingBottom: "14%",

      [theme.breakpoints.down("sm")]: {
        paddingTop: "30%",
        paddingLeft: "0",
        paddingRight: "0"
      },
    },
}));

const Search = styled('div')(({ theme }) => ({
  position: 'relative',
  borderRadius: theme.shape.borderRadius,
  backgroundColor: alpha(theme.palette.common.white, 0.15),
  '&:hover': {
    backgroundColor: alpha(theme.palette.common.white, 0.25),
  },
  marginLeft: 0,
  width: '100%',
  [theme.breakpoints.up('sm')]: {
    marginLeft: theme.spacing(1),
    width: 'auto',
  },
}));

const SearchIconWrapper = styled('div')(({ theme }) => ({
  padding: theme.spacing(0, 2),
  height: '100%',
  position: 'absolute',
  pointerEvents: 'none',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
}));

const StyledInputBase = styled(InputBase)(({ theme }) => ({
  color: 'inherit',
  '& .MuiInputBase-input': {
    padding: theme.spacing(1, 1, 1, 0),
    // vertical padding + font size from searchIcon
    paddingLeft: `calc(1em + ${theme.spacing(4)})`,
    transition: theme.transitions.create('width'),
    width: '100%',
    [theme.breakpoints.up('sm')]: {
      width: '12ch',
      '&:focus': {
        width: '20ch',
      },
    },
  },
}));

const columns = [
  { 
    id: 'name', 
    label: 'Nama', 
    minWidth: 170 
  },
  { 
    id: 'category', 
    label: 'Kategori', 
    minWidth: 170 
  },
  { 
    id: 'createdAt_formattted', 
    label: 'Tanggal Pembuatan', 
    minWidth: 170,
    align: 'center', 
    type: "dateTime",
  },
  { 
    id: 'updatedAt_formattted', 
    label: 'Update Terakhir', 
    minWidth: 170,
    align: 'center', 
    type: "dateTime",
  },
  {
    id: 'status',
    label: 'Status',
    minWidth: 100,
    align: 'center'
  },
  {
    id: 'action',
    label: 'Aksi',
    minWidth: 100,
    align: 'center'
  }
];


const Templates = () => {
  const dispatch = useDispatch()
  const classes = useStyles();
  const history = useHistory()

  const [data, setData] = React.useState([]);    
  const [page, setPage] = React.useState(0);
  const [rows, setRows] = React.useState([]);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);

  const [listOrderInput, setListOrderInput] = React.useState('Terbaru');
  const [searchInput, setSearchInput] = React.useState('');

  const handleSearchChange = event => {
    setSearchInput(event.target.value);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  const handleNewBroadcast = () => {
    history.push('/broadcast/newBroadcast')
  }

  const handleNewTemplate = () => {
    history.push('/broadcast/newTemplate')
  }

  useEffect(() => {
    dispatch(fetchTemplates())
  }, [dispatch])

  const templates = useSelector(state => state.broadcastReducer.templates)

  useEffect(() => {
    setData(templates)
  }, [templates])

  useEffect(() => {
    const results = [...templates].filter(template =>
      template.name.toLowerCase().includes(searchInput)
    );
    setData(results);
  }, [searchInput]);

  useEffect(() => {
    switch (listOrderInput) {
      case 'Terbaru':
        const templatesAsc = [...templates].sort(function(a,b){
          return new Date(b.createdAt) - new Date(a.createdAt)
        })
        setData(templatesAsc)
        break;
      case 'Terlama':
        const templatesDesc = [...templates].sort(function(a,b){
          return new Date(a.createdAt) - new Date(b.createdAt)
        })        
        setData(templatesDesc)
        break;
      default:
        break;
    }
  }, [listOrderInput]);

  useEffect(() => {
    const rowsData = []
    data?.forEach(d => {
      switch (d.type) {
        case 'text':
          d.category = 'Pesan'
          break;
        case 'image':
          d.category = 'Gambar'
          break;
        case 'pdf':
          d.category = 'Dokumen'
          break;
        default:
          break;
      }

      const dt = Moment(d.createdAt).format('DD MMMM YYYY')
      const tm = Moment(d.createdAt).format('HH:mm')
      const tz = new Date(d.createdAt).getTimezoneOffset() < 0 ?
                  `+${-(new Date(d.createdAt).getTimezoneOffset()/60)}`
                  :
                  `-${-(new Date(d.createdAt).getTimezoneOffset()/60)}`
      d.createdAt_formattted = `${dt} | ${tm} (GMT ${tz})`

      const dt_u = Moment(d.updatedAt).format('DD MMMM YYYY')
      const tm_u = Moment(d.updatedAt).format('HH:mm')
      const tz_u = new Date(d.updatedAt).getTimezoneOffset() < 0 ?
                  `+${-(new Date(d.updatedAt).getTimezoneOffset()/60)}`
                  :
                  `-${-(new Date(d.updatedAt).getTimezoneOffset()/60)}`
      d.updatedAt_formattted = `${dt_u} | ${tm_u} (GMT ${tz_u})`

      // if (d.status === 'success') {
      //   rowsd.push({
      //     id: d._id,
      //     name: d.customerName,
      //     date: d.timestamp,
      //     login: d.category,
      //     status: <Chip icon={<CircleIcon className='font-size-10 text-green' />} label="Berhasil" variant="outlined" />  
      //   })      
      // } else {
      //   rowsData.push({
      //     id: d._id,
      //     name: d.customerName,
      //     date: d.timestamp,
      //     login: d.category,
      //     status: <Chip icon={<CircleIcon className='font-size-10 text-red' />} label="Gagal" variant="outlined" />
      //   })      
      // }
      rowsData.push({
        id: d._id,
        name: d.name,
        category: d.category,
        createdAt_formattted: d.createdAt_formattted,
        updatedAt_formattted: d.updatedAt_formattted,
        status: <Chip icon={<CircleIcon className='font-size-10 text-green' />} label="Disetujui" variant="outlined" />  
      })      
    })
    setRows(rowsData)
  }, [data])
  
  const handleListOrder = (e) => {
    setListOrderInput(e.target.value)
  }
     
  return (
        <React.Fragment>
        <Header page='Templates'/>
        <CssBaseline />
        <Menubar/>
        <Grid item xs={12} md={12} className={classes.contentCreateApp}>
          <main className={classes.layoutMainCreateApp}>
            <Grid container style={{position: 'relative'}}>
              <Box className="d-flex mb-15 w-100" style={{ justifyContent: 'space-between' }}>
                <div style={{justifyContent:'space-between'}}>
                  <Button
                    variant="contained"
                    color="primary"
                    className="btn-white text-transform-unset"
                    style={{padding: "5px 10px"}}
                    onClick={handleNewTemplate}
                    >
                    + Buat Template Baru
                  </Button>
                  <Button
                    className="ml-5 btn-white text-transform-unset"
                    >
                      <img src="/icon-download.png" alt="icon-download" width="18px" height="20px"/>
                  </Button>
                </div>
                <Button
                variant="contained"
                color="secondary"
                className="btn-black text-transform-unset"
                style={{padding: "5px 10px"}}
                onClick={handleNewBroadcast}
                >
                Buat Broadcast Baru
                </Button>
              </Box>
              <Box className="d-flex mb-15 w-100" style={{ justifyContent: 'space-between' }}>
                <div className="d-flex" style={{justifyContent:'space-between'}}>
                  <Search style={{border: "1px solid #dadada"}}>
                    <SearchIconWrapper>
                      <SearchIcon />
                    </SearchIconWrapper>
                    <StyledInputBase
                      placeholder="Cari Template"
                      className="font-size-14 mr-5"
                      inputProps={{ 'aria-label': 'search' }}
                      value={searchInput}
                      onChange={handleSearchChange}
                    />
                  </Search>
                  {/* <div className="d-flex ml-5" style={{justifyContent:"space-between", padding:"4px 3px", border: "1px solid #dadada"}}>
                    <img src="/icon-filter.png" alt="icon-filter" width="18px" height="20px"/>
                    <ArrowDropDownSharpIcon className='dropbtn'/>
                  </div> */}
                </div>
                <div className="d-flex" style={{justifyContent:'space-between'}}>
                  <span className="font-size-14 mt-5 mr-5"> Urut Berdasarkan: </span>
                  <Box sx={{ minWidth: 120 }}>
                    <FormControl fullWidth>
                      <NativeSelect
                        defaultValue={'Terbaru'}
                        inputProps={{
                          name: 'age',
                          id: 'uncontrolled-native',
                        }}
                        variant='outlined'
                        className="font-size-14"
                        onChange={handleListOrder}
                      >
                        <option value={'Terbaru'}>Terbaru</option>
                        <option value={'Terlama'}>Terlama</option>
                      </NativeSelect>
                    </FormControl>
                  </Box>
                </div>
              </Box>
              <Paper sx={{ width: '100%', overflow: 'hidden' }} className={classes.tableRoot}>
                <TableContainer sx={{ maxHeight: 380 }}>
                  <Table stickyHeader aria-label="sticky table">
                    <TableHead>
                      <TableRow>
                        <TableCell>
                          Nama Template
                        </TableCell>
                        <TableCell  align="center">
                          Kategori
                        </TableCell>
                        <TableCell align="center">
                          Tanggal Pembuatan
                        </TableCell>
                        <TableCell align="center">
                          Update Terakhir
                        </TableCell>
                        <TableCell align="center">
                          Status
                        </TableCell>
                        <TableCell align="center">
                          Aksi
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody stripedRows >
                      {rows
                        .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                        .map((row) => {
                          return (
                            <TableRow hover role="checkbox" tabIndex={-1} key={row.id}>
                              {columns.map((column) => {
                                const value = row[column.id];
                                return (
                                  <TableCell key={column.id} align={column.align}>
                                    {column.format && typeof value === 'number'
                                      ? column.format(value)
                                      : value}
                                  </TableCell>
                                );
                              })}
                            </TableRow>
                          );
                        })}
                    </TableBody>
                  </Table>
                </TableContainer>
                <TablePagination
                  rowsPerPageOptions={[10, 25, 100]}
                  component="div"
                  count={rows.length}
                  rowsPerPage={rowsPerPage}
                  page={page}
                  onPageChange={handleChangePage}
                  onRowsPerPageChange={handleChangeRowsPerPage}
                />
              </Paper>
            </Grid>

          </main>
        </Grid>
      </React.Fragment>     
    )
}

export default Templates
